import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import auth        from '../services/auth';
/**
 * HOC that Handles whether or not the user is allowed to see the page.
 * @param {array} allowedRoles - user roles that are allowed to see the page.
 * @returns {Component}
 */

export default function Authorization(allowedRoles) {
    //const user=auth.getUserInfo();
  return (WrappedComponent) => {
    const WithAuthorization = () => {
       //const { user } = props;
       const user = auth.getUserInfo();
       console.log('Athorization user', user);
       if (user!== null){
        if (allowedRoles.includes(user.userTypeName)) {
          return <WrappedComponent {...user} />;
        }
        return <h1>No page for you!</h1>; // Redirect actually
       }
     return null;
    };
    function mapStateToProps() {
      //const { user } = state.user;
      const user =auth.getUserInfo();
      return {
        user,
      };
    }
    WithAuthorization.propTypes = {
      user: PropTypes.shape({
        //id: PropTypes.number.isRequired,
        firstName: PropTypes.string.isRequired,
        userTypeName: PropTypes.string.isRequired,
       
      },
      ),
    };
    // return connect(state => ({ user: state.user.user }))(WithAuthorization);
   return connect(mapStateToProps)(WithAuthorization);
   
  };
}


// WEBPACK FOOTER //
// ./src/app/routes/Authorization.js